/**
* Bug #518
* @Author Liya Baby
* @Date 26 July 2021
*/
// Components in private routing 
import { Usertype } from "config/UserTypes";
const Doctor = Usertype[0];
const Public = Usertype[1];

//Patient routers
//Doctor routers
export const DoctorLogin = { path: Doctor.login, label: "Doctor" }
export const MyPatients = { path: Doctor.user + "/my-patients", label: 'Patients' }
export const MyPatientList = { path: Doctor.user + "/my-patient", label: 'Patients' }/** Bug #939 Midhila velayudhan 15/06/2022 */
export const DoctorChatMessage = { path: Doctor.user + "/chat-doctor", label: 'Message' }
//export const DoctorDashboards = { path: Doctor.dashboard, label: 'Dashboard' }/***  Bug #598  @Author Anupama P  @Date 28 Aug 2021  */
export const ScheduleTimings = { path: Doctor.user + "/schedule-timing", label: 'Schedule Timing' }
export const DoctorPasswords = { path: Doctor.user + "/change-passwword", label: 'Change Password' }
export const Appointment = { path: Doctor.user + "/appointments", label: 'Appointments' }
export const PatientProfiles = { path: Doctor.user + "/patient-profile", label: 'Patient Profile' }
export const DoctorProfileSetting = { path: Doctor.user + "/profile-settings", label: 'Profile Settings' }
export const Reviews = { path: Doctor.user + "/review", label: 'Reviews' }
export const DoctorRegisters = { path: Doctor.user + "/doctor-register", label: 'Register' }
export const QrCodePractice = { path: Doctor.user + "/qrcode", label: 'Practice QR code' }
export const DoctorInvoice = { path: Doctor.user + "/invoice", label: "Invoice" }
export const SocialMedias = { path: Doctor.user + "/social-media", label: "Social Media" }
export const DoctorInvoiceView = { path: Doctor.user + "/invoice-view", label: "Invoice" }
export const DoctorForm = { path: Doctor.user + "/doctors-form", label: "Forms" }
export const BroadcastMessage = { path: Doctor.user + "/broadcast-message", label: "Broadcast Message" }/***  Bug #748  @Author Liya @Date 31 Jan 2022  */
export const ScheduleBroadcast = { path: Doctor.user + "/schedule-broadcast", label: "Broadcast Message" }/***  Bug #748  @Author Liya @Date 31 Jan 2022  */
export const PatientList = { path: Doctor.user + "/patient-list", label: "Patient List" }/***  Bug #748  @Author Liya @Date 1 Feb 2022  */
export const FormListItem = { path: Doctor.user + "/form", label: "Forms" }/***  Bug #748  @Author Liya @Date 1 Feb 2022  */
export const DoctorSettings = { path: Doctor.user + "/settings", label: 'Settings' } /*** Bug #1012  @Author Linda Susan Raju @Date 26 Sept 2022 */
export const DoctorAppoinmentSettings = { path: Doctor.user + "/appointment-settings", label: 'Appointment Settings' } /*** Bug #1012  @Author Linda Susan Raju @Date 26 Sept 2022 */

export const PatientForms = { path: Doctor.user + "/patientforms", label: "Patient Forms"} /** Bug #1011 Midhila Velayudhan Date : 16 aug 2022 */
export const AppointmentReminder = { path: Doctor.user + "/appointment-reminder", label: "Reminders" }/***  Bug #748  @Author Liya @Date 31 Jan 2022  */
export const PatientGroups = { path: Doctor.user + "/patient-groups", label: "Patient Groups" }/***  Bug #841  @Author Aby Joseph @Date 19 Apr 2022 */
export const AddPatientGroups = { path: Doctor.user + "/add-patient-group", label: "Patient Groups" }/***  Bug #841  @Author Aby Joseph @Date 19 Apr 2022 */
export const Template = { path: Doctor.user + "/template-message", label: "Templates" }/* Bug #838  Midhila Velayudhan @Date 17 april 2022  */
export const TemplateMessages = { path: Doctor.user + "/template-messages", label: "Template" }/*Bug #838  Midhila Velayudhan @Date 18 april 2022  */
export const Providers = { path: Doctor.user + "/providers", label: "Providers" }/*Bug #860  Aby Joseph @Date 28 april 2022  */


//Components in public routing
export const VirtualCheckIns = { path: Public.user + "/virtual-checkin", label: 'Virtual Check In' }
export const AppointmentsVirtualCheckIn = { path: Public.user + "/appointments-virtual-checkin", label: 'Virtual Check In Appointments' }


export const SearchDoctors = { path: Public.user + "/search", label: "Search a Doctor" }
export const SearchProfileInfo = { path: Public.user + "/profile/:slug", label: "Profile" }
// export const DoctorProfiles={ path: Public.user+"/profile/:slug", label: "Profile" }
export const Bookings = { path: Public.user + "/booking", label: "New Appointment" }
// export const PracticeProfiles={ path: Public.user+"/profile/:slug", label: "Profile" }


export const LoginContainers = { path: ["/login","/"], label: "Login" }
export const DoctorRegister = { path: "/register", label: "Register" }
export const ForgotPasswords = { path: "/forgot-password", label: "Forgot Password" }
export const Homes = { path: "/", label: "Home" }
export const Home1s = { path: "/home1", label: "Home1" }
export const Home2s = { path: "/home2", label: "Home2" }
export const ConfirmAccounts = { path: "/confirm-account/:token", label: "Confirm Account" }
export const ResetPasswords = { path: "/reset-password/:token", label: "Reset Password" }
export const NewPatients = { path: "/new-patient", label: "New Patient" }

//Component for New design

export const Blog = { path: Public.user + "/blog/blog-list", label: 'Blog' }
export const BlogDetailsInfo = { path: Public.user + "/blog/blog-details", label: 'BlogDetails' }
export const BlogDetailsInfo2 = { path: Public.user + "/blog/blog-details2", label: 'BlogDetails2' }
export const BlogDetailsInfo3 = { path: Public.user + "/blog/blog-details3", label: 'BlogDetails3' }
export const BlogDetailsInfo4 = { path: Public.user + "/blog/blog-details4", label: 'BlogDetails4' }
export const LogoutMobiles = { path: "/logoutMobile", label: 'Logout' }/*Bug #588 - Logout from mobile app - Modified by Jithin Kuriakose on 03Sept2021*/
export const QrcodeInfo = { path: "/ccdascan", label: "Personal Health Record & Demographics" }
export const Personalccda = { path: "/personalCcda", label: "Health Record" }

export const PageNotFoundPath = { path: "/404", label: "404" }
export const PatientQrDemographic = { path: "/personalDemographics", label: 'Demographics' }/**#610 - @Author - Linda Susan Raju @Date - 20Sept2021*/
/**Bug #610 @Author Anupama P @Date 21 Sep 2021 */



 export const PaymentOtp = { path: Public.user + "/otpVerification", label: 'Verify OTP' }

/**End Bug#698 */
export const ApptUrls = { path: "/appt/:slugAction/:slug", label: 'Appt Url' }/** Bug #808  @Author Aby @Date 22 Mar 2022*//** Bug #823 - Appointment recall url management for - Registered Hello Health users @Author Jithin Kuriakose @Date 06Apr22**/
export const AppReferences = { path: "/app-reference", label: 'Download App' }/* Bug #808  @Author Aby @Date 16 Mar 2022  */

export const ViewPatientGroup = { path: Doctor.user + "/view-patientgroup", label: ''} /** Bug #841 Midhila Velayudhan Date : 29 april 2022 */


export const UpdateAccessTokenMobiles = { path: "/update-token", label: 'Update Token' }/**Bug #855 - Refresh token management in web, Bug #854 @Author Jithin Kuriakose @Date 26Apr2022 */

export const DoctorMessaging = { path: Doctor.user +'/messages', label: 'Messages'}//Bug #1072 @Author Anupama @date 12Oct2022
export const SSoMessaging = { path: '/sso/message/:c', label: 'Messages'}//Bug #1072 @Author Anupama @date 12Oct2022
export const SSoMessages = { path: '/sso/messages/', label: 'Messages'}//Bug #1072 @Author Anupama @date 12Oct2022

